import { CheckboxStyled, TextStyled } from '@nike/nike-design-system-components';
import React from 'react';
import PropTypes from 'prop-types';
import useBodega from '../../utils/hooks/bodegaHook';
import templateString from '../../utils/templateString';
import { CookieCheckboxContainer } from './styles';

const CookieCheckbox = ({ label, body, readOnly, name, onChange, isChecked }) => {
  const title = useBodega(label.id, label.defaultMessage);
  const text = templateString(useBodega(body.id, body.defaultMessage), body.templateValues);
  const checkboxId = `cookie-checkbox-${name}`;

  return (
    <CookieCheckboxContainer data-testid={`cookie-checkbox-container-${name}`}>
      <CheckboxStyled
        checked={isChecked}
        disabled={readOnly}
        id={checkboxId}
        label={title}
        onChange={() => onChange(name)}
        slots={{
          LabelSlot: (
            <div className="cookieCheckboxLabelSlot">
              <label htmlFor={checkboxId}>{title}</label>
              <TextStyled appearance="legal">{text}</TextStyled>
            </div>
          ),
        }}
      />
    </CookieCheckboxContainer>
  );
};

CookieCheckbox.propTypes = {
  label: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  body: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
    templateValues: PropTypes.object,
  }),
  readOnly: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
};

export default CookieCheckbox;
